module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "banner_section"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._m(1, false, false), _vm._v(" "), _vm._l((_vm.homeSlide), function(row, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": row.image,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(row.id) + "\n\t\t\t\t\t\t")])])
  })], 2), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _vm._m(3, false, false)])]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('section', {
    staticClass: "step_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "jcarousel-wrapper"
  }, [_c('div', {
    staticClass: "jcarousel"
  }, [_c('ul', [_c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-1.png'
    }
  })]), _vm._v(" "), _vm._m(6, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-2.jpg'
    }
  })]), _vm._v(" "), _vm._m(7, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-3.jpg'
    }
  })]), _vm._v(" "), _vm._m(8, false, false)])]), _vm._v(" "), _c('li', {
    staticClass: "step_box"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('figure', {
    staticClass: "pic justify"
  }, [_c('img', {
    attrs: {
      "src": '/static/images/index/3-4.jpg'
    }
  })]), _vm._v(" "), _vm._m(9, false, false)])])])]), _vm._v(" "), _c('a', {
    staticClass: "jcarousel-control-prev",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("‹")]), _vm._v(" "), _c('a', {
    staticClass: "jcarousel-control-next",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("›")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "news_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', {
    staticClass: "title main_title session_title"
  }, [_vm._v("最新消息")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.news), function(row, index) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "news_box"
    }, [_c('div', {
      staticClass: "date"
    }, [_c('span', {
      staticClass: "day"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(row.c_date)))]), _vm._v(" "), _c('span', {
      staticClass: "month"
    }, [_vm._v(_vm._s(_vm._f("formatMonth")(row.c_date)) + "月")])]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.c_title))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("truncate")(row.c_content, 50)) + "\n\t\t\t\t\t\t\t\t"), _c('router-link', {
      staticClass: "pull-right more",
      attrs: {
        "to": '/news/' + index
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t了解更多"), _c('span', {
      staticClass: "glyphicon glyphicon-menu-right",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])])
  }))])]), _vm._v(" "), _c('section', {
    staticClass: "store_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h4', {
    staticClass: "title main_title session_title"
  }, [_vm._v("合作廠商")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.companies), function(row, index) {
    return _c('div', {
      staticClass: "col-md-2 col-xs-6"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [(row.com_image) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    }) : _vm._e()]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))])])], 1)])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carousel-example-generic",
      "data-slide-to": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item active"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/index/banner3.jpg",
      "alt": "i80愛幫您"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature_section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("即時成效")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台即時呈現銷售資訊與追踪工具讓您瞭解通路表現，是精準且穩定的網路平台。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-time icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("最高獎金")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台每件商品個人都享有10%的返利，推薦越多享受更多。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-usd icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("優質商品")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("平台負責把關所有上架商品，讓消費者放心購買。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/operators"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-thumbs-up icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "feature_box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("服務專員")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("提供線上與實體客服，讓您快速了解平台與商品特色。")]), _vm._v(" "), _c('a', {
    staticClass: "more",
    attrs: {
      "href": "/contact"
    }
  }, [_vm._v("了解更多"), _c('span', {
    staticClass: "glyphicon glyphicon-menu-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "glyphicon glyphicon-user icon",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('h4', {
    staticClass: "title main_title"
  }, [_vm._v("i80：賺取回饋金三步驟")]), _vm._v(" "), _c('p', [_vm._v("加入平台並使用推廣連結分享商品，當網友由連結導入至推廣的商品完成購買，您就即可獲取回饋金。")]), _vm._v(" "), _c('p', [_vm._v("簡單三步驟，您也能成為網路推廣者，趕緊加入愛幫您的行列吧!")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default i80_btn",
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("免費加入會員")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我該如何選擇產品？")]), _vm._v(" "), _c('p', [_vm._v("加入愛幫您：找你喜歡、有興趣、或專長領域的商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我可以在哪裡推廣？")]), _vm._v(" "), _c('p', [_vm._v("可以透過個人社群軟體、部落格親友、拜訪等做宣傳")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我怎麼獲得獎金？")]), _vm._v(" "), _c('p', [_vm._v("透過分享後，只要有產生消費，系統就會立即計算獎金給您")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h5', [_vm._v("我該如何選擇產品？")]), _vm._v(" "), _c('p', [_vm._v("加入聯盟網：找你喜歡、有興趣、或專長的商品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e75def9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Main.vue
// module id = 281
// module chunks = 1